<template>
    <section class="gallery-blocks-container" oncontextmenu="return false" :class="{'grid-four' : horizontalVideo}" fetchpriority="high">
        <div class="first-column">
            <div v-if="mainBlockImage"
                 class="gallery-block main-block"
                 :class="{'skeleton-box' : mainBlockImage.loading}"
                 :style="{background: `${blocksColor}`}"
                 @click="openZoomGallery()">
                 <prz-picture v-if="!mainBlockImage.loading" :fetchpriority="'high'" :key="hashPath(mainBlockImage.src)" :details="pictureMain" :class-box="'w-100 h-100'" />
            </div>
            <div v-else class="gallery-block main-block skeleton-box"/>
        </div>
        <transition name="fade">
            <div v-if="secondColumnBlocks" class="second-column">
                <div v-for="(block, index) in secondColumnBlocks" class="gallery-block"
                     :class="{'horizontal-block' : block.horizontal, 'is-video' : block.videoBlock, 'skeleton-box' : block.loading }"
                     :data-position="index+1" :key="block.title+'-'+index" :id="'elem-'+index"
                     :style="{background: !block.videoBlock ? `${blocksColor}` : 'transparent'}"
                     @click="clickGalleryBlock(block)" >

                    <Single v-if="block.horizontal && block.videoBlock" :key="hashPath(block.videoBlock)"  :item="productVideoBlock"/>
                    
                    <prz-picture v-else-if="!block.loading" :fetchpriority="'high'" :key="hashPath(block.src)" :details="pictureStruct(block)" :class-box="'w-100 h-100'" />

                    <!-- extras -->
                    <div v-if="remainingImages && (index == secondColumnBlocks.length - 1)" class="remaining-layer">
                        {{ '+' + remainingImages }}
                    </div>
                </div>
            </div>
            <div v-else class="second-column">
                <div class="gallery-block skeleton-box"/>
                <div class="gallery-block skeleton-box"/>
                <div class="gallery-block skeleton-box"/>
                <div class="gallery-block skeleton-box"/>
            </div>
        </transition>
        <transition name="fade">
            <ZoomGallery v-if="showZoomGallery && zoomGalleryData"
                :zoom-gallery-data="zoomGalleryData"
                @close-zoom="showZoomGallery = false"/>
        </transition>
    </section>
</template>

<script>

import { storePdp } from '@/store/product-page';
import { isEmpty } from 'lodash-es';

import PrzPicture from '@/components/Muffin/Picture.vue';
import Single from "@/components/Blocks/Block/Single.vue";
import { BlockContent } from "@/models/Blocks/Itens/block-content";
import { TemplateItemType } from "@/models/Blocks/Itens/Types/template-item-type";
import { BlockItemAction } from "@/models/Blocks/Itens/Types/block-content-types";
import { Picture } from '@/models/Muffin/picture';
import { MD5 } from "@/models/identify";

export default {
    store: storePdp,
    name: 'GalleryBlocks',
    components: {
        Single,
        PrzPicture,
        ZoomGallery: () => import("@/components/ProductPage/Desktop-BlackRabbit/BlocksSection/Content/ZoomGallery.vue"),
    },
    props: {
        galleryData: {type: Object, default: null, required: true},
    },
    data() {
        return {
            selectedPosition: 1,
            showZoomGallery: false
        };
    },
    computed: {
        blocksColor() {
            const blocksColor = this.$store.getters.blocksColor;
            return blocksColor ? blocksColor : '#333';
        },
        kStrings() {
            return this.$store.getters.kStrings;
        },
        groupId() {
            return this.$store.getters.GroupId;
        },
        sku() {
            return this.galleryData ? this.galleryData.sku : null;
        },
        images() {
            //let imgData = [];
            if (isEmpty(this.galleryData)) {
                return null;
            }
            return this.galleryData.images;
        },
        isNutrition(){
            return this.galleryData?.isNutrition?? false;
        },
        mainBlockImage() {
            if(!isEmpty(this.images)) {
                return this.images[0];
            }

            return null;
        },
        pictureMain(){
            return this.pictureStruct(this.mainBlockImage);
        },
        secondColumnBlocks() {

            if(!isEmpty(this.images)) {
                let horizontalVideo = this.horizontalVideo;
                let isNutrition    = this.isNutrition;
                let filteredImages = horizontalVideo ? 
                        this.images.filter( (elm) => {
                            if(isNutrition && (elm.position == 2 || elm.position == 3)){
                                return false;
                            }else{
                                return elm.position > 1 && elm.position < (isNutrition ? 6 : 4);
                            }
                        }) : 
                        this.images.filter(elm => elm.position > 1 && elm.position < 6);
                if (horizontalVideo) {
                    //filteredImages = this.images.filter(elm => elm.position > 1 && elm.position < 4);
                    let videoImage = {
                        src: horizontalVideo.options.poster,
                        horizontal: true,
                        videoBlock: horizontalVideo.source,
                    };

                    filteredImages.unshift(videoImage);
                }

                return filteredImages;
            }

            return null;
        },
        thumbs() {
            if (isEmpty(this.galleryData)) {
                return null;
            }

            return this.galleryData.thumbs;
        },
        videos() { // normal videos
            if (isEmpty(this.galleryData)) {
                return null;
            }

            return !isEmpty(this.galleryData.videos) ? this.galleryData.videos : null;
        },
        horizontalVideo() { // main video
            if (isEmpty(this.videos)) {
                return null;
            }

            let horizontalVideo = this.videos.VH;
            if (!horizontalVideo) {
                return null;
            }

            return {
                source: horizontalVideo.video,
                sourceFull: horizontalVideo.video,
                options: {
                    poster: horizontalVideo.image, // TODO ADD HORIZONTAL IMAGE
                    autoPlay: true,
                    loop: true,
                    muted: true,
                    fullScreenStart: false,
                },
            };
        },
        productVideoBlock() {
            if (isEmpty(this.videos)) {
                return null;
            }

            const action = new BlockItemAction('video', null, null, 'prz-fullscreen');
            let struct = new BlockContent(null, action);
            struct.cssClass = 'prz-blk-content-no-gradient';
            struct.addImage(this.horizontalVideo.options.poster, null, true);
            struct.templateType = TemplateItemType.horizontal;
            struct.backgroundColor = 'transparent';
            struct.setVideo(this.horizontalVideo.source, this.horizontalVideo.options.poster);

            return struct;
        },
        zoomImages() {
            if (isEmpty(this.galleryData)) {
                return null;
            }

            return this.galleryData.zoomImages;
        },
        isMod() {
            return this.galleryData.isMod;
        },
        remainingImages() {
            if(isEmpty(this.images)) {
                return 0;
            }

            let remaining = this.images.length - 5;
            if (this.horizontalVideo && !this.isNutrition) {
                remaining += 2;
            }

            return remaining > 0 ? remaining : 0;
        },
        zoomGalleryData() {
            if (!this.images) {
                return null;
            }

            return {
                groupId: this.groupId,
                sku: this.sku,
                images: this.images,
                zoomImages: this.zoomImages,
                thumbs: this.thumbs,
                defaultPosition: this.selectedPosition
            }
        }
    },
    methods: {
        hashPath(path){
            if(path){
                return MD5.generation(path);
            }else{
                return MD5.generation(Math.random().toString());
            }
        },
        openZoomGallery(position = 1) {
            this.selectedPosition = position;
            this.showZoomGallery = true;
        },
        clickGalleryBlock(block){
            return !block.videoBlock ? this.openZoomGallery(block.position??1) : this.playVideo();
        },
        playVideo() {
            const parseObj = {
                url: this.horizontalVideo.source,
                poster:  this.horizontalVideo.options.poster
            };

            this.$store.commit('pdpDesktop/updateVideoModal', {show: true, videoData: parseObj})
        },
        pictureStruct(block){
            let list = [];
            if(!block){
                return undefined;
            }

            if(block.srcWebp){
                list.push({url: block.srcWebp, condition: '1x'});
            }
            
            if(block.srcset){
                let tmp = block.srcset.split(' ');
                if(tmp.length >= 2){
                    list.push({url: tmp[0], condition: tmp[1]});
                }
            }

            if(block.srcsetWebp){
                let tmp = block.srcsetWebp.split(' ');
                if(tmp.length >= 2){
                    list.push({url: tmp[0], condition: tmp[1]});
                }
            }
            
            let p = new Picture(block.src,list);
            p.title  = block.title??'';
            return p;
        },
    },
    // created() {},
    // mounted() {
    //     this.$nextTick(() => {});
    // },
};
</script>

<style lang="scss">
@import "./styles/BlocksSection/galleryBlocks.scss";
</style>
